export default __webpack_public_path__ + "static/media/B_Besouro.78c0aa4b.mp3";